module.exports = require("@pb/kit-component-multiline-ellipsis");